"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationPremium = function IllustrationPremium() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "65",
    height: "65",
    fill: "none",
    viewBox: "0 0 65 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeWidth: "1.5",
    d: "M45.54 25.019c-.571-.532-.79-1.375-.483-2.085l.263-.665c.44-1.02-.131-2.173-1.185-2.484l-.703-.177a1.85 1.85 0 01-1.318-1.686v-.754a1.823 1.823 0 00-2.108-1.73l-.703.133c-.79.133-1.537-.221-1.889-.931l-.35-.621a1.801 1.801 0 00-2.636-.621l-.571.4a1.837 1.837 0 01-2.108 0l-.571-.444c-.879-.666-2.153-.355-2.68.62l-.351.622a1.823 1.823 0 01-1.932.931l-.703-.133c-1.098-.178-2.065.62-2.152 1.73l-.044.71a1.849 1.849 0 01-1.318 1.685l-.703.222c-1.054.31-1.625 1.463-1.186 2.484l.264.665c.307.71.088 1.552-.483 2.085l-.527.487c-.835.71-.835 2.04 0 2.75l.527.488c.57.533.79 1.375.483 2.085l-.264.665c-.439 1.02.132 2.174 1.186 2.484l.703.178a1.85 1.85 0 011.318 1.685l.044.71a1.823 1.823 0 002.108 1.73l.703-.134c.79-.133 1.537.222 1.888.932l.351.621a1.801 1.801 0 002.636.62l.57-.398a1.837 1.837 0 012.11 0l.57.443c.879.666 2.152.355 2.68-.62l.35-.622a1.823 1.823 0 011.933-.931l.703.133c1.098.177 2.064-.621 2.152-1.73l.044-.71a1.85 1.85 0 011.318-1.685l.702-.177c1.055-.31 1.626-1.464 1.186-2.484l-.263-.666c-.308-.71-.088-1.552.483-2.084l.527-.488c.834-.71.834-2.04 0-2.75l-.571-.488z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "32.737",
    cy: "27",
    r: "9",
    fill: "#F3F1F5",
    stroke: "#77558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.737 22l1.122 3.455h3.633l-2.939 2.135 1.123 3.455-2.94-2.135-2.938 2.135 1.123-3.455-2.94-2.135h3.633L32.737 22z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#77558A",
    strokeWidth: "1.5",
    d: "M18.924 51.454l4.304-10.867c.57.266 1.23.444 1.888.444.264 0 .527-.044.791-.089h.088l.044.089c.746 1.42 2.284 2.306 3.953 2.306.439 0 .922-.088 1.317-.221l-4.524 11.487a.427.427 0 01-.79.045l-2.152-3.815c-.088-.133-.22-.177-.352-.133l-4.04 1.286a.408.408 0 01-.527-.532zM38.644 54.737l-4.568-11.533c.44.133.879.222 1.318.222a4.45 4.45 0 003.953-2.35l.044-.09h.088c.263.045.527.09.79.09.703 0 1.318-.178 1.933-.444l4.304 10.955c.132.355-.175.71-.527.577l-4.04-1.286c-.132-.045-.264 0-.352.133l-2.152 3.814c-.176.267-.659.222-.79-.088z"
  }));
};

var _default = IllustrationPremium;
exports.default = _default;